import { PageContainer } from '../../components/PageContainer';
import { useSigmaJwt } from '../../shared/hooks/use-sigma-jwt';

export const Sigma = () => {
  const { sigmaJwt } = useSigmaJwt();

  console.info(sigmaJwt.data);

  return (
    <PageContainer>
      <iframe
        src={sigmaJwt?.data?.signedEmbedUrl}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </PageContainer>
  );
};
